module.exports = __webpack_public_path__ + "img/r50-100.e915b797.png";